import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';

import { Observable, tap } from 'rxjs';
import { ReportTimezoneService } from '../report-timezone.service';

const REPORT_TIMEZONE_HEADER = 'Report-Timezone';
const REPORT_TIMEZONE_NAME_HEADER = 'Report-Timezone-Name';

@Injectable()
export class ReportTimezoneInterceptor implements HttpInterceptor {

    private reportTimezoneService = inject(ReportTimezoneService);

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const timeRangeVersion = this.reportTimezoneService.currentTimeRangeVersion();
        return next.handle(request).pipe(
            tap(event => {
                if (!(event instanceof HttpResponse)) {
                    return;
                }
                const timezone = event.headers.get(REPORT_TIMEZONE_HEADER);
                if (timezone) {
                    const name = event.headers.get(REPORT_TIMEZONE_NAME_HEADER) ?? timezone;
                    this.reportTimezoneService.record({ timezone, name }, timeRangeVersion);
                }
            })
        );
    }
}
